import { getMaximalMonthlyPrice } from './getMaximalMonthlyPrice';
import { getPriceDisplayProps } from './getPriceDisplayProps';
import { findCyclePricing } from './findCyclePricing';
import { getMonthlyPrice } from './pricingCalculations';
export const cyclePriceDisplayPropsFromProductPricing = _ref => {
  let {
    interval,
    salePricing,
    catalogPricing,
    currencySettings,
    maximalMonthlyPrice: maximalMonthlyPriceFromInput,
    quantity
  } = _ref;
  const cycleSalePricing = findCyclePricing(interval, salePricing);
  const cycleCatalogPricing = findCyclePricing(interval, catalogPricing);
  const isCycleInSale = Boolean(cycleSalePricing);
  const cycleCatalogPricePerMonth = Number(getMonthlyPrice(cycleCatalogPricing));
  const maximalMonthlyPrice = (() => {
    if (maximalMonthlyPriceFromInput) {
      return maximalMonthlyPriceFromInput;
    }
    if (isCycleInSale) {
      return cycleCatalogPricePerMonth;
    }
    return getMaximalMonthlyPrice({
      catalogPricing
    });
  })();
  const currentCyclePricing = cycleSalePricing ?? cycleCatalogPricing;
  if (!currentCyclePricing || !currentCyclePricing.monthsPerCycle) {
    throw new Error(`No cycle pricing found for interval: ${interval}`);
  }
  return getPriceDisplayProps({
    currencySettings,
    maximalMonthlyPrice,
    monthlyPrice: Number(getMonthlyPrice(currentCyclePricing)),
    monthsPerCycle: currentCyclePricing == null ? void 0 : currentCyclePricing.monthsPerCycle,
    quantity
  });
};
//# sourceMappingURL=cyclePriceDisplayPropsFromProductPricing.js.map